import { useEffect, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import api from "@/lib/api";
import { BADGE_TIERS } from "@/components/StreakBadges";
import { playTone } from "@/lib/sounds";

export function BadgeCelebrationHost() {
  const [badge, setBadge] = useState(null);

  const check = useCallback(() => {
    api.get("/badges/pending").then(({ data }) => {
      if (!data.pending?.length) return;
      const top = Math.max(...data.pending);
      setBadge(BADGE_TIERS.find((t) => t.n === top) || null);
      playTone("badge");
      api.post("/badges/ack").catch(() => {});
    }).catch(() => {});
  }, []);

  useEffect(() => {
    check();
    const h = () => setTimeout(check, 2500);
    window.addEventListener("wallet:refresh", h);
    return () => window.removeEventListener("wallet:refresh", h);
  }, [check]);

  return (
    <AnimatePresence>
      {badge && (
        <motion.div className="fixed inset-0 z-[110] flex items-center justify-center px-6" data-testid="badge-unlock-popup"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={() => setBadge(null)} />
          <motion.div initial={{ scale: 0.5, rotate: -8, opacity: 0 }} animate={{ scale: 1, rotate: 0, opacity: 1 }}
            transition={{ type: "spring", stiffness: 260, damping: 16 }}
            className={`relative w-full max-w-sm rounded-3xl pz-glass border p-8 text-center ${badge.ring}`}>
            {[...Array(12)].map((_, i) => (
              <motion.span key={i} className="absolute left-1/2 top-24 h-2 w-2 rounded-full bg-pazer-red"
                initial={{ x: 0, y: 0, opacity: 1 }}
                animate={{ x: Math.cos((i / 12) * Math.PI * 2) * 140, y: Math.sin((i / 12) * Math.PI * 2) * 140, opacity: 0 }}
                transition={{ duration: 1.2, ease: "easeOut" }} />
            ))}
            <motion.div animate={{ scale: [1, 1.12, 1] }} transition={{ repeat: Infinity, duration: 1.6 }}
              className="mx-auto mb-5 h-24 w-24 rounded-3xl bg-black/50 flex items-center justify-center">
              <badge.icon className={`h-14 w-14 ${badge.color}`} />
            </motion.div>
            <div className="text-xs uppercase tracking-[0.3em] text-white/50 mb-1">Badge unlocked</div>
            <h2 className="font-display font-extrabold text-3xl mb-1" data-testid="badge-unlock-name">{badge.name}</h2>
            <p className="text-white/60 text-sm mb-6">{badge.n} wins in a row. Keep the streak alive!</p>
            <button onClick={() => setBadge(null)} data-testid="badge-unlock-close"
              className="w-full py-3 rounded-full bg-pazer-red hover:bg-pazer-redhover font-bold transition-colors">Awesome!</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
